// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const toEuroCurrency = (amount: number) =>
  new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
